import styled from 'styled-components';
import Search from '../../../../BaseComponentWrappers/MotifSearch';

export default styled(Search)`
	.motif-input-component {
		.motif-input {
			width: var(--px-300);
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		svg {
			vertical-align: middle;
		}
	}
`;
